import type { MetricsStreamingFormat } from "../miContenidoExportData";

export type MetricsStreamingLabels = {
  /** Compact label for platform rows / ranking legend. */
  promAvg: string;
  /** Totales KPI on Resumen del período (more space). */
  promAvgKpi: string;
  peak: string;
  promAvgLong: string;
  /** Dual-line weekly chart title when avg+peak are merged. */
  mergedLive: string;
  streamsPlural: string;
  rankingSubtitle: string;
};

const LIVE_LABELS: MetricsStreamingLabels = {
  promAvg: "Prom. en vivo",
  promAvgKpi: "Prom. espect. en vivo",
  peak: "Peak en vivo",
  promAvgLong: "Promedio en vivo",
  mergedLive: "En vivo",
  streamsPlural: "Livestreams",
  rankingSubtitle: "YouTube videos y livestreams",
};

const PREMIERE_LABELS: MetricsStreamingLabels = {
  promAvg: "Prom. estreno",
  promAvgKpi: "Prom. espect. estrenos",
  peak: "Peak estreno",
  promAvgLong: "Prom. estrenos",
  mergedLive: "Estrenos",
  streamsPlural: "Estrenos",
  rankingSubtitle: "YouTube videos y estrenos",
};

const MIXED_LABELS: MetricsStreamingLabels = {
  ...LIVE_LABELS,
  streamsPlural: "Livestreams / Estrenos",
  rankingSubtitle: "YouTube videos, livestreams y estrenos",
};

export function metricsStreamingLabels(
  format: MetricsStreamingFormat = "live",
): MetricsStreamingLabels {
  if (format === "premiere") return PREMIERE_LABELS;
  if (format === "mixed") return MIXED_LABELS;
  return LIVE_LABELS;
}

/**
 * Live vs premiere presence among typed streams.
 * Both live and premiere → mixed (formats: Livestreams / Estrenos).
 */
export function deriveStreamingPresence(
  streams: Array<{ streamType?: string }> | null | undefined,
): MetricsStreamingFormat {
  const known = (streams ?? [])
    .map((s) => s.streamType)
    .filter((t): t is string => typeof t === "string" && t.length > 0);
  const relevant = known.filter((t) => t === "live" || t === "premiere");
  if (relevant.length === 0) return "live";

  const hasLive = relevant.some((t) => t === "live");
  const hasPremiere = relevant.some((t) => t === "premiere");
  if (hasLive && hasPremiere) return "mixed";
  if (hasPremiere) return "premiere";
  return "live";
}
